var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.399,
    height: 27.52,
    viewBox: "0 0 34.399 27.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.4,16.32,27.08,6H6.44A3.45,3.45,0,0,0,3,9.44V30.1A3.435,3.435,0,0,0,6.44,33.52l27.52-.017A3.435,3.435,0,0,0,37.4,30.08ZM25.36,8.58l9.46,9.46H25.36Z",
    transform: "translate(-3 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialNote);
export default __webpack_public_path__ + "static/media/material-note.c29a90c9cb199b3999eed4e94c5e327d.svg";
export { ForwardRef as ReactComponent };